import { Icon } from '../../../icon/Icon';
import Duration from '../../../shared/components/Duration/Duration';
import { Tooltip } from '../../../tooltip/Tooltip';
import { JobLatency } from '../../interfaces/job';
import { LatencyTooltipContent } from './LatencyTooltipContent';

interface LatencyWrapperProps {
  latency: JobLatency;
  showIcon?: boolean;
  latencyNotApplicable: boolean;
}

export function LatencyWrapper({
  latency,
  showIcon = true,
  latencyNotApplicable
}: LatencyWrapperProps) {
  if (latencyNotApplicable) {
    return <span>N/A</span>;
  }

  return (
    <Tooltip
      dataId=''
      disableInteractive={false}
      disabled={!latency.maxLatency}
      title={<LatencyTooltipContent latency={latency} />}
    >
      <div className='center-flex-row text-ellipsis'>
        {showIcon && latency.maxLatency ? <Icon name='hourglass-25' /> : null}
        <span className='text-ellipsis'>
          <Duration
            duration={latency.maxLatency!}
            options={{ useAbbr: true, separateUnits: true }}
          />
        </span>
      </div>
    </Tooltip>
  );
}
